<template>
  <span class="extra-price">
    {{
      paymentScheme === 'supplier' && currency !== 'USD'
        ? $t(`${base}.price_supplier`, {
            amount: amount.format(true),
            currency,
            usd: amountUsdCurrency.format(true),
          })
        : $t(`${base}.price`, {
            amount: amount.format(true),
            currency,
          })
    }}
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadExtraPrice',
  props: {
    product: { type: Object, required: true },
    currency: { type: String, required: true },
    base: { type: String, required: true, default: 'experience.extras' },
  },
  computed: {
    ...mapState('experience', {
      paymentScheme: (state) => state.experience.payment_scheme,
    }),
    ...mapState('settings', {
      exchangeRate: 'exchange_rate',
    }),
    amount() {
      const value =
        this.product.price *
        (this.product.unit ? this.product.unit : 1) *
        (this.product.capacity ? this.product.capacity : 1)

      return this.$options.filters.ladFnCurrency(
        value,
        this.currency,
        false,
        '',
        0
      )
    },
    currentRate() {
      const exchange = this.exchangeRate.find((t) => t.code === this.currency)

      return exchange ? exchange.rate : 0
    },
    toCurrency() {
      return 'USD'
    },
    amountUsdCurrency() {
      let value = this.amount

      if (this.currentRate > 0) {
        value =
          this.currentRate < 1
            ? value.multiply(this.currentRate)
            : value.divide(this.currentRate)
      }

      return this.$options.filters.ladFnCurrency(
        value,
        this.toCurrency,
        false,
        '',
        0
      )
    },
  },
}
</script>
